import { Interface } from '@ethersproject/abi'
import STAKING_REWARDS_JSON from '@uniswap/liquidity-staker/build/StakingRewards.json'

const STAKING_REWARDS_INTERFACE = new Interface(STAKING_REWARDS_JSON.abi)

export { STAKING_REWARDS_INTERFACE }
